<body class="gray">

<!-- Wrapper -->
<div id="wrapper">

<app-header-mainsearch-result></app-header-mainsearch-result>

<div class="clearfix"></div>
<!-- Header Container / End -->

<!-- Titlebar
================================================== -->
<div id="titlebar" class="gradient" style="font-family: 'Kanit'">
	<div class="container">
		<div class="row">
			<div class="col-md-12">

				<h2 style="font-family: 'Kanit'">ข้อเสนอแนะ</h2>

				<!-- Breadcrumbs -->
				<nav id="breadcrumbs" class="dark">
					<ul>
						<li><a href="index.html">หน้าหลัก</a></li>
						<li>ข้อเสนอแนะ</li>
					</ul>
				</nav>

			</div>
		</div>
	</div>
</div>


<!-- Content
================================================== -->


<!-- Container -->
<div class="container" style="font-family: 'Kanit'">
	<div class="row">

		<!-- <div class="col-xl-12">
			<div class="contact-location-info margin-bottom-50">
				<div class="contact-address" style="font-family: 'Kanit'">
					<ul>
						<li class="contact-address-headline">กรมพัฒนาธุรกิจการค้า กระทรวงพาณิชย์</li>
						<li>563 ถ.นนทบุรี ต.บางกระสอ อ.เมือง จังหวัดนนทบุรี 11000</li>
						<li><a style="color: #7A56AA" title="Call Center" data-tippy-placement="top"><i class="icon-feather-phone-call"></i> 1570</a></li>
						<li><a style="color: #7A56AA" title="E-Mail" data-tippy-placement="top"><i class="icon-feather-mail"></i> example@dbd.go.th</a></li>
						<li>
							<div class="freelancer-socials">
								<ul>
									<li><a href="https://th-th.facebook.com/pages/category/Government-Organization/DBD-Public-Relations-415527945210102/" target="_blank" title="Facebook" data-tippy-placement="top"><i class="icon-brand-facebook-square"></i></a></li>
									<li><a href="https://twitter.com/relationdbd" target="_blank" title="Twitter" data-tippy-placement="top"><i class="icon-brand-twitter-square"></i></a></li>
									<li><a href="https://www.youtube.com/channel/UCRriY2_Wv3QjySb1MlxdPzQ" target="_blank" title="YouTube" data-tippy-placement="top"><i class="icon-brand-youtube-square"></i></a></li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
				<div id="single-job-map-container">
					<div id="singleListingMap" data-latitude="13.8825757" data-longitude="100.4865682" data-map-icon="im im-icon-Hamburger"></div>
					<a href="#" id="streetView">Street View</a>
				</div>
			</div>
		</div> -->

		<div class="col-xl-8 col-lg-8 offset-xl-2 offset-lg-2" style="font-family: 'Kanit'">

			<section id="contact" class="margin-bottom-60" >
				<h3 class="headline margin-top-15 margin-bottom-30" style="font-family: 'Kanit'">คุณสามารถส่งข้อเสนอแนะ เกี่ยวกับบริการค้นหาและแนะนำรหัสประเภทธุรกิจ (TSIC)<br>ผ่านแบบฟอร์มติดต่อด้านล่าง</h3>

				<form method="post" name="contactform" id="contactform" autocomplete="on" style="font-family: 'Kanit'">
					<!-- <div class="row">
						<div class="col-md-6">
							<div class="input-with-icon-left">
								<input class="with-border" name="name" type="text" id="name" placeholder="ชื่อผู้ติดต่อ" required="required" />
								<i class="icon-material-outline-account-circle"></i>
							</div>
						</div>

						<div class="col-md-6">
							<div class="input-with-icon-left">
								<input class="with-border" name="email" type="email" id="email" placeholder="อีเมลของผู้ติดต่อ" pattern="^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$" required="required" />
								<i class="icon-material-outline-email"></i>
							</div>
						</div>
					</div> -->

					<div class="input-with-icon-left">
						<input class="with-border" name="subject" type="text" id="subject" placeholder="หัวเรื่อง" required="required" />
						<i class="icon-material-outline-assignment"></i>
					</div>

					<div>
						<textarea class="with-border" name="comments" cols="40" rows="5" id="comments" placeholder="ข้อเสนอแนะ" spellcheck="true" required="required"></textarea>
					</div>

					<input type="button" class="submit button margin-top-15" id="saveFeedBack" value="ส่งข้อเสนอแนะ" />

				</form>
			</section>

		</div>

	</div>
</div>
<!-- Container / End -->

<!-- Footer
================================================== -->
<div id="footer">

	<!-- Footer Copyrights -->
	<div class="footer-bottom-section">
		<div class="container">
			<div class="row">
				<div class="col-xl-12">
					ติดต่อเรา กองข้อมูลธุรกิจ โทร 02-547-4391
				</div>
				<div class="col-xl-12">
					จัดทำโดย กรมพัฒนาธุรกิจการค้า กระทรวงพาณิชย์ (สนามบินน้ำ) 563 ถ.นนทบุรี ต.บางกระสอ อ.เมือง จ.นนทบุรี 11000
				</div>
				<div class="col-xl-12">
					© 2020 <strong>Department of Business Development</strong>. All Rights Reserved.
				</div>
			</div>
		</div>
	</div>
	<!-- Footer Copyrights / End -->

</div>
<!-- Footer / End -->

</div>
<!-- Wrapper / End -->

</body>
